import { useMemo } from "react";
import Svg, { Path } from "react-native-svg";
import { Platform, View } from "react-native";

import type { IconProps } from "./types";
export function ExclamationCircleSolid({
  size = 24,
  color,
  style,
  ...props
}: Omit<IconProps, "width" | "height" | "viewBox" | "fill">) {
  const defaultColor = useMemo(
    () => (Platform.OS === "web" ? "currentcolor" : "black"),
    []
  );
  const component = (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ? color : defaultColor}
      {...props}
    >
      <Path
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c.004-5.523-4.477-10-10-10zm.021 16.573a.81.81 0 110-1.621.81.81 0 010 1.62zm.811-4.648a.81.81 0 11-1.622 0l.013-7.58a.81.81 0 111.622 0l-.013 7.58z"
        fill={color ? color : defaultColor}
      />
    </Svg>
  );

  if (style) {
    return <View style={style}>{component}</View>;
  }

  return component;
}
